// src/index.ts
import { defineApp } from "@ex0/kernel";
import { FitAddon } from "@xterm/addon-fit";
import { Terminal } from "@xterm/xterm";
import "@xterm/xterm/css/xterm.css";
var src_default = defineApp({
  id: "terminal",
  name: "Terminal",
  description: "Terminal emulator",
  icon: "/icons/icon_042_64x64.png",
  window: {
    title: "Terminal",
    size: { width: 700, height: 400 },
    constraints: { minWidth: 300, minHeight: 200 }
  },
  mount(container, ctx) {
    const fitAddon = new FitAddon();
    const term = new Terminal({
      convertEol: true,
      fontFamily: "'Fira Mono', monospace",
      fontSize: 15,
      fontWeight: 400,
      theme: {
        background: "black",
        foreground: "white"
      }
    });
    const el = document.createElement("div");
    el.style.cssText = "width:100%;height:100%;background:#222;";
    container.appendChild(el);
    term.loadAddon(fitAddon);
    term.open(el);
    fitAddon.fit();
    term.write("Welcome to ex0 shell v1.0");
    let env = { pwd: "/home" };
    let commandBuffer = "";
    const io = {
      write: (text) => term.write(text),
      writeln: (text) => term.write("\r\n" + text)
    };
    const prompt = () => term.write("\r\n$ ");
    prompt();
    term.onKey(async ({ key, domEvent }) => {
      switch (domEvent.key) {
        case "Enter":
          if (commandBuffer.trim()) {
            term.write("\r\n");
            try {
              const result = await ctx.kernel.exec(
                commandBuffer.trim(),
                io,
                env
              );
              if (result.env) {
                env = { ...env, ...result.env };
              }
            } catch (e) {
              term.write("\r\nerror: " + e);
            }
          }
          commandBuffer = "";
          prompt();
          break;
        case "Backspace":
          if (commandBuffer.length > 0) {
            commandBuffer = commandBuffer.slice(0, -1);
            term.write("\b \b");
          }
          break;
        case "ArrowLeft":
        case "ArrowRight":
          break;
        default:
          if (key.length === 1 && !domEvent.ctrlKey) {
            commandBuffer += key;
            term.write(key);
          }
      }
    });
    return {
      dispose() {
        term.dispose();
      },
      onFocus() {
        term.focus();
      },
      onResize() {
        fitAddon.fit();
      }
    };
  }
});
export {
  src_default as default
};
